import { render, staticRenderFns } from "./manageAttachments.vue?vue&type=template&id=52f3f622"
import script from "./manageAttachments.ts?vue&type=script&lang=js&external"
export * from "./manageAttachments.ts?vue&type=script&lang=js&external"
import style0 from "./manageAttachments.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports